import React from "react";
import Head from "next/head";

import { Brand } from "custom-types/Brand";
import useDomain from "hooks/useDomain";
import formatImgixUrl from "utils/formatImgixUrl";

import { SailthruMetaTags } from "../SailthruMetaTags";
export const BrandHead: React.FC<{
  brand: Brand;
  children?: JSX.Element[] | JSX.Element | string;
}> = ({ brand }) => {
  const domain = useDomain();

  const { description, logo, name, tagline, slug } = brand;
  const title = `${[name, tagline].filter((s) => !!s).join(": ")} | Leafly`;
  const generalDescription = `Learn about ${name} including who they are, their products, and where you can find them.`;
  const shortDescription =
    description?.length > 200 ? `${description.slice(0, 199)}…` : description;
  const logoUrl = formatImgixUrl(logo);
  const tags = [
    name,
    "brand-page",
    ...brand.availableStates,
    ...brand.availableCountries,
  ];

  return (
    <Head>
      <title>{title}</title>

      <link rel="canonical" href={`${domain}/brands/${slug}`} />

      <meta name="description" content={generalDescription} />

      {logoUrl && (
        <meta property="og:image" content={`${logoUrl}?w=1200&fm=jpg`} />
      )}
      <meta
        property="og:description"
        content={shortDescription || generalDescription}
      />
      <meta property="og:title" content={title} />
      <meta property="og:type" content="webpage" />

      <link
        rel="alternate"
        href={`https://www.leafly.ca/brands/${brand.slug}`}
        hrefLang="en-ca"
      />
      <link
        rel="alternate"
        href={`https://www.leafly.com/brands/${brand.slug}`}
        hrefLang="en-us"
      />

      <SailthruMetaTags
        description={shortDescription || generalDescription}
        imageUrl={logoUrl}
        tags={tags}
        title={title}
      />
    </Head>
  );
};
